import React from "react";
import styled from "styled-components";

import { ThemeContext } from "../../containers/ThemeContext";
import CarPageAvatar from "../CarPageAvatar";
import ContactWrapper from "./ContactWrapper";
import Footer from "../Footer";

const LeftWrapper = styled.div`
  display: block;
  position: absolute;
  left: 0;
  top: 160px;
  width: 350px;
  z-index: 1;
  border-right: 30px solid white;

  > div {
    padding-top: 15px;
  }

  @media (max-width: 767.98px) {
    top: 60px;
    position: relative;
    margin: 0 auto;
    border: none;
  }
`;

const ModalCarContactWrapperStyles = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  z-index: 990;
  overflow: scroll;
`;

class ModalCarContactWrapper extends React.Component {
  render() {
    return (
      <ModalCarContactWrapperStyles>
        <div className="split split__rent grey-color">
          <div className="section-contact container container-small">
            <div className="row">
              <LeftWrapper>
                {this.props.carData && (
                  <CarPageAvatar
                    modal
                    carData={this.props.carData}
                    calculatorData={this.props.calculator}
                  />
                )}
              </LeftWrapper>
              <div className="col-12 col-md-10 offset-md-2 right-side grey-color right-side-calc">
                <div className="row">
                  <div className="col-12 col-md-8 offset-md-4 car-price-list--wrapper">
                    <ContactWrapper
                      hideModalContact={this.props.hideModalContact}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer mobileHide />
      </ModalCarContactWrapperStyles>
    );
  }
}

ModalCarContactWrapper.contextType = ThemeContext;

export default ModalCarContactWrapper;
